import { transformHTMLToText } from "../transform/htmlToText.transform.js";
import BaseModel from "./_mbase.js";
import FieldModel from "./FieldModel.js";

class FieldOptionModel extends BaseModel {

    value = '';
    text = '';
    isDefault = 0;
    lowercaseValue = '';
    name = '';
    linkFieldId = null;
    image

    get name2() {
        return this.name
    }

    constructor() {
        super();
    }

    fromJSON(data) {
        super.fromJSON(data);
        this.value = data['value'];
        this.text = data['display_value'];
        this.isDefault = data['is_default'];
        this.linkFieldId = data['link_field_id']
        this.lowercaseValue = this.value.toLowerCase().trim();
        this.image = data['image']
        return this;
    }

    setName(name) {
        this.name = name;
        return this;
    }

    toJSON() {

    }

    /**
     * @returns {string}
     */
    toDisplayPlainText() {
        return transformHTMLToText(this.text);
    }

    compareValue(value) {
        return this.lowercaseValue === value.toLowerCase();
    }

    getValue() {
        return this.value;
    }
}

export default FieldOptionModel;